/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadge8S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13.058 10.23c0 .507-.353.837-1.06.99-.707-.153-1.06-.483-1.06-.99 0-.553.353-.83 1.06-.83s1.06.277 1.06.83zm-2.3 3.15c0-.64.413-1.037 1.24-1.19.827.153 1.24.55 1.24 1.19 0 .327-.11.583-.33.77-.213.187-.517.28-.91.28-.387 0-.69-.093-.91-.28s-.33-.443-.33-.77z" />
        <path d="M11.305 2.281a1 1 0 0 1 1.39 0l1.874 1.813 2.581-.365a1 1 0 0 1 1.125.817l.45 2.568 2.303 1.221a1 1 0 0 1 .43 1.323L20.313 12l1.145 2.342a1 1 0 0 1-.43 1.323l-2.302 1.221-.45 2.568a1 1 0 0 1-1.126.817l-2.581-.365-1.874 1.813a1 1 0 0 1-1.39 0L9.43 19.906l-2.58.365a1 1 0 0 1-1.126-.817l-.45-2.568-2.303-1.222a1 1 0 0 1-.43-1.322L3.687 12 2.542 9.658a1 1 0 0 1 .43-1.323l2.303-1.221.45-2.568A1 1 0 0 1 6.85 3.73l2.581.365zm2.683 12.779c.48-.38.72-.907.72-1.58 0-.4-.113-.757-.34-1.07-.22-.313-.52-.55-.9-.71.7-.373 1.05-.893 1.05-1.56 0-.613-.22-1.09-.66-1.43s-1.06-.51-1.86-.51-1.42.17-1.86.51c-.44.34-.66.817-.66 1.43 0 .667.35 1.187 1.05 1.56-.38.16-.683.397-.91.71-.22.313-.33.67-.33 1.07 0 .673.24 1.2.72 1.58.48.38 1.143.57 1.99.57.853 0 1.517-.19 1.99-.57z" />
      </g>
    </g>
  </Icon>
);
export { SvgBadge8S as Badge8S };
